const keys = {
  validation: {
    error: {
      accountLength: 'Account number must contain between 7 and 12 digits',
      alternaBankTransit: 'Alterna Bank transit number must be 00016',
      alternaSavingsTransit: 'Alterna Savings transit number must be 00646',
      between5And12DigitsAccount: 'Account number must contain between 5 and 12 digits',
      between6And9DigitsAccount: 'Account number must contain between 6 and 9 digits',
      between7And10DigitsAccount: 'Account number must contain between 7 and 10 digits',
      between7And12DigitsAccount: 'Account number must contain between 7 and 12 digits',
      booleanRequired: 'Should be a boolean',
      choiceNotIncluded: 'The choice is not included in the list',
      cityRequired: 'Enter city name',
      countryInvalid: 'Country must be Canada',
      countryRequired: 'Country is required',
      creditorsExceedLength: 'Creditors length exceeds the number of non owned cars',
      mortgageLendersExceedLength: 'Mortgage lenders length exceeds the number of mortgages',
      dateGreaterThanToday: 'Should not be greater than today',
      dateInferiorThanToday: 'Should be greater than today',
      dateInvalid: 'Should be a valid date',
      driverLicenceG2BeforeG1_self: 'Your G2 age must be at least the same as your G1 licensed age',
      driverLicenceG2BeforeG1_other: "This driver's G2 age must be at least the same as their G1 licensed age",
      driverLicenceGSameOrBeforeG2_self: 'Your G age must be at least a year after your G2 licensed age',
      driverLicenceGSameOrBeforeG2_other: "This driver's G age must be at least a year after their G2 licensed age",
      driverLicenceMaxGapBeforeG: 'Must obtain a G licence within 5 years',
      eightDigitsAccount: 'Account number must be 8 digits long',
      endDateInvalid: 'Should be a valid date',
      fiveDigitsTransit: 'Transit number must be 5 digits long',
      invalidAddress: 'Address is required',
      invalidAlphanumeric: 'Must only contains digits or letters',
      invalidArraySize: 'Number of items is incorrect',
      invalidCarDateOfClaim: 'Date of claim should not be older than 6 years',
      invalidCarPossessionDate: 'Possession year must match with the year of your car',
      invalidStringLength: 'Must be at least 2 characters',
      invalidCharacters: 'Includes invalid characters',
      invalidConstructionYear: 'Should be a valid year',
      invalidConvictionYear: 'Conviction should not be older than 5 years',
      invalidCurrency: 'Should be a valid value',
      invalidEffectiveDates: 'Should include a date for each product type',
      invalidFiledClaims: 'Must be between 0 and 2',
      invalidFireHydrantDistance: 'Please select a valid distance',
      invalidFireStationDistance: 'Please select a valid distance',
      invalidDriverLicenceClass: 'Must have a valid licence class',
      invalidDriverLicenceObtainedAtAge: "Must be between 16 years old and the driver's current age",
      invalidFirstDriverLicenceAge: 'Must be 16 years old or older',
      invalidFloorNumber: 'Invalid floor number',
      invalidHomeDimension: 'Required',
      invalidHomeReconstructionCost: 'Amount must be between 80k and 2M',
      invalidHomeDateOfClaim: 'Date of claim should not be older than 8 years',
      invalidFinancialInstitutionNumber: 'Institution number should be 3 digits',
      invalidLicenseAgeToBirthday: 'Must be less than your age',
      invalidLicenceNumber: 'Invalid licence number',
      invalidMonth: 'Should be a valid month',
      invalidMoveInDate: 'Move in date must be after construction year',
      mustBeAfterConstructionYear: 'Must be after construction year',
      invalidName: 'Should be at least 2 letters',
      invalidNumberOfBathrooms: 'Number of bathrooms must be between 1 and 9',
      invalidNumberOfStoreys: 'Should be a number between 1 and 9',
      invalidNumberOfUnits: 'Should be a valid number of units',
      invalidNumberOfYearsInsured: 'Should be a valid number of years',
      invalidNumberYearsContinuouslyInsured: 'Must be between 0 and 5',
      invalidNumberYearsWithCurrentInsurer: 'Must be between 0 and 4',
      invalidPhoneNumber: 'Should be a valid phone number',
      invalidPhoneNumberCountry: 'Should be a valid phone number in Canada or United States',
      policyNumbersShouldBeDifferent: 'This policy number is already used for another product within this application.',
      invalidPolicyNumber: {
        economical: 'Economical policy number format must be 123456789',
        intact: 'Intact policy number format must be xxx-xxxx for Québec and xxxxxxxxx for Ontario',
        unique: 'Unique policy number format must be 12345678',
        promutuel: 'Promutuel policy number format must be x0123456789-01',
        travelers: 'Travelers policy number format must be 0123456789 or APP0123456',
        wawanesa: 'Wawanesa policy number format must be 12345678',
      },
      invalidPropertySize: 'Invalid property size',
      invalidProvince: 'Province is not supported',
      invalidPurchaseKmOnOdometer: 'Must be between 0 and 9999 km',
      invalidInstallationYear: 'Must be between your home construction year and the current year',
      invalidSize: 'Should be a valid size',
      invalidString: 'Invalid value',
      invalidUnit: 'Invalid unit number or invalid PO BOX format',
      invalidVin: 'Invalid VIN',
      invalidWaterTankYear: 'Must be between 1900 and today',
      invalidYearlyDaysOutsideOfProvince: 'Invalid value',
      invalidYearlyKilometers: 'Must be between 1,000 and 999,000.',
      invalidDailyKilometers: 'Must be between 1 and 999.',
      invalideAge: 'Invalid age',
      invalidValue: 'Invalid value',
      latitude: 'Latitude must be between -90 and 90',
      longitude: 'Longitude must be between -180 and 180',
      mainDriverIsRequired: 'Main driver is required',
      nineDigitsAccount: 'Account number must be 9 digits long.',
      policyLength: 'The policy number must contains at least 4 characters',
      possessionDateAfter: "Acquisition date must be the same year or after the car's year model.",
      presidentChoiceTransit: "President's choice Bank transit number must be 02002",
      provinceRequired: 'Select your province',
      required: 'This field is required',
      selectOption: 'Select an option from the list',
      sevenDigitsAccount: 'Account number must be 7 digits long',
      sevenOrTwelveAccount: 'Account number must be either 7 or 12 digits long',
      sixDigitsAccount: 'Account number must be 6 digits long',
      startWith00Transit: 'Transit number must begin with 00XXX and be 5 digits long',
      startWith10Transit: 'Transit number must begin with 10XXX and be 5 digits long',
      startWith80Transit: 'Transit number must begin with 80XXX and be 5 digits long',
      streetNameRequired: 'Enter street name',
      streetNumberRequired: 'Enter street number',
      tangerineTransit: 'Tangerine transit number must be 00152',
      tenDigitsAccount: 'Account number must be 10 digits long',
      transitLength: 'Transit number must contain 5 digits',
      twelveDigitsAccount: 'Account number must be 12 digits long',
      unknownProduct: 'Unknown product.',
      undefinedRequired: 'Should be undefined',
      validEmail: 'Please enter a valid email',
      validPassword: 'Should be a valid password',
      validPostalCode: 'Valid format is H3B 2Y4',
      wealthsimpleTransit: 'Wealthsimple transit number must be 00001',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
